import { Loader2 } from 'lucide-react'
import { primaryEntityActionButtonClass, secondaryEntityActionButtonClass } from '@/components/ui/entityActionButtonClasses'
import { cn } from '@/lib/utils/helpers'
import type { EmailTemplateAddEditFormProps } from '../../types/components'

export function EmailTemplateFormActions({ page }: EmailTemplateAddEditFormProps) {
  const { saving, navigate } = page

  return (
    <div className="border-t border-slate-200 bg-white px-4 py-4 sm:px-6 -mx-4 sm:-mx-6 mt-6">
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="submit"
          disabled={saving}
          className={cn(primaryEntityActionButtonClass, 'px-4 py-2')}
          data-testid="email-template-addedit-submit"
        >
          {saving && <Loader2 className="h-4 w-4 animate-spin" />}
          {saving ? 'Saving…' : 'Submit'}
        </button>
        <button
          type="button"
          onClick={() => navigate('/email-templates')}
          disabled={saving}
          className={cn(secondaryEntityActionButtonClass, 'px-4 py-2')}
        >
          Cancel
        </button>
      </div>
    </div>
  )
}
